module.exports = __webpack_public_path__ + "img/e5a9c4e.svg";